import script from "./Sunyuan.vue?vue&type=script&setup=true&lang=js"
export * from "./Sunyuan.vue?vue&type=script&setup=true&lang=js"

import "./Sunyuan.vue?vue&type=style&index=0&id=29eec5d1&lang=less&scoped=true"
script.__scopeId = "data-v-29eec5d1"

export default script